/*eslint-env jquery*/
import React, { Component } from 'react'
import { connect } from 'react-redux'
// import { Link } from 'react-router-dom'
// import { toastr } from 'react-redux-toastr'
import MySweetAlert from '../../Shared/MySweetAlert'
import Loading from '../../Shared/Loading'
// import OperationIcon from '../../Shared/OperationIcon'
// import Select from 'react-select'
import { unitTasksService } from '../../../_services/unitTasks.service'
import TaskCode from '../../Shared/TaskCode'
// import { FaPlus } from 'react-icons/fa'
import { FaBars } from 'react-icons/fa'
import { FiTrash2 } from 'react-icons/fi'
import { GiMagnifyingGlass } from 'react-icons/gi'
import { MdPlaylistAddCheck, MdAdd } from 'react-icons/md'
import { Field, FastField, ErrorMessage, getIn, Formik } from 'formik'
// import config from '../../../config'
// import NumberFormat from 'react-number-format'
// import ImportExcel from './ImportExcel'
import UnitSelectBtnList from './UnitSelectBtnList'
// import measurementTypes from '../../../_constants/measurementTypes'
import Form from './Form'
import StartTaskForm from './StartTaskForm'
import { Tabs, Tab } from 'react-bootstrap'
// import { AsyncCategorySelect } from '../../Shared/AsyncCategorySelect'
import AsyncBrandSelect from '../../Shared/AsyncBrandSelect'

import DatePicker from '../../Shared/DatePicker'
import { DecimalInput } from 'react-hichestan-numberinput'

import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import DialogTitle from '@material-ui/core/DialogTitle'
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'
// import AsyncCategorySelect from '../../Shared/AsyncCategorySelect'
// import AsyncBrandSelect from '../../Shared/AsyncBrandSelect'

import moment from 'moment-jalaali'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

class SClumTasks extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      data: [],
      loading: false,
      modal: false,
      model: {},
      confirmDeleteShow: false,
      activeTab: 'tasks',
      tab_name: undefined,
      tab_title: undefined,
      selectUnitModal: true,
      unitTaskStatus: this.props.unitTaskStatus,
      dto: {
        page: 0,
        pageSize: 0,
        unitTaskStatus: this.props.unitTaskStatus,
        sorted: { id: 'createdAt', desc: false }
      },
      totalRecords: 0,
      unitId: undefined
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectUnitModal !== this.state.selectUnitModal) {
      this.setState({ selectUnitModal: nextProps.selectUnitModal })
    }
  }

  handleModalHide = e => {
    var evt = e || window.event // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault()
    }
    this.setState({ modal: false, model: {} })
  }

  handleModalHideAndReload = e => {
    var evt = e || window.event // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault()
    }
    this.setState({ modal: false, model: {} }, () => {
      this.getData()
    })
  }

  handleUnitSelect = (val, name) => {
    this.setState({ loading: true })

    if (val) {
      // this.props.onChange(name)
      let dto = this.state.dto
      dto['unitId'] = val
      this.setState(
        { dto: dto, selectUnitModal: false, tab_name: name, unitId: val },
        () => {
          this.getData()
        }
      )
    }
  }

  getData() {
    // console.log(JSON.stringify(this.state.dto));
    this.setLoading(true)
    unitTasksService
      .getAllSClum(JSON.stringify(this.state.dto))
      .then(res => {
        console.log(res.data)

        let tab_title = this.state.tab_name
        if (res.data.totalRecords > 0) {
          tab_title =
            tab_title + '   (تعداد سفارشات : ' + res.data.totalRecords + ' عدد)'
        }

        this.setState(
          {
            data: res.data.data,
            totalRecords: res.data.totalRecords,
            tab_title: tab_title,
            searchModal: false
          },
          () => {
            this.setLoading(false)
          }
        )
      })
      .catch(error => {
        console.log(error)
        this.setState({ searchModal: false })
        this.setLoading(false)
      })
  }

  handleModalEdit = _model => {
    this.setState({ modal: true, model: _model })
  }

  setLoading = val => {
    this.setState({ loading: val }, () => {})
  }

  handleSearch = values => {
    this.setState({ loading: true })
    if (values) {
      this.setState({ dto: values, page: 0 }, () => {
        this.getData()
      })
    }
  }

  handleShowAll = () => {
    var dto = {
      page: 0,
      pageSize: this.state.dto.pageSize,
      unitId: this.state.dto.unitId,
      sorted: { id: 'createdAt', desc: true }
    }
    console.log(this.state.dto)

    this.setState({ dto: dto }, () => {
      this.getData()
    })
  }

  render() {
    const {
      dto,
      data,
      loading,
      tab_title,
      activeTab,
      model,
      searchModal
    } = this.state
    return (
      <div>
        {/* <div className="row text-right">
            <div className="col-sm-12">
              <div className="react-table-top-area">
                <span className="records-info">{`تعداد کل: ${this.state.totalRecords}`}</span>

                <div>
                  <a onClick={() => this.setState({ selectUnitModal: true })} className="btn btn-primary btn-sm pull-left" style={{ margin: 0, fontSize: 14 }} disabled={loading}>
                    <FaBars size="14px" style={{ verticalAlign: 'middle', marginLeft: 10 }} />&nbsp;انتخاب دستگاه</a>
                </div>

              </div>
            </div>
            <div className="clearfix"></div>
            <br />
          </div> */}

        <div className="noPaddingTabs">
          <div>
            <a
              onClick={() => this.handleShowAll()}
              className="btn btn-primary pull-left btn-sm"
              disabled={loading}
              style={{ margin: 0, marginLeft: 5 }}>
              <MdPlaylistAddCheck
                size="20px"
                style={{ verticalAlign: 'middle' }}
              />
              &nbsp;نمایش همه
            </a>

            <a
              onClick={() =>
                this.setState({ modalHeading: 'جستجو', searchModal: true })
              }
              className="btn btn-sm btn-primary pull-left"
              style={{ margin: 0, marginLeft: 5 }}
              disabled={loading}>
              <GiMagnifyingGlass
                size="20px"
                style={{ verticalAlign: 'middle' }}
              />
              &nbsp;جستجو
            </a>

            <Dialog
              open={searchModal && !loading}
              TransitionComponent={Transition}
              fullWidth={true}
              maxWidth="xs"
              onClose={() => this.setState({ searchModal: false })}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
              // style={{ overflow: 'visible' }}
            >
              <DialogTitle>
                <Fab
                  color="secondary"
                  aria-label="refresh"
                  size="small"
                  onClick={() => this.setState({ searchModal: false })}
                  className="modal-close-btn">
                  <MdClose
                    size="20px"
                    className={loading ? 'mdi-spin mdi-loading' : ''}
                  />
                </Fab>
              </DialogTitle>
              <DialogContent className="search-modal">
                {loading && <Loading />}

                <Formik
                  enableReinitialize
                  initialValues={this.state.dto}
                  onSubmit={(values, { setSubmitting }) => {
                    // // console.log(values);
                    this.handleSearch(values)
                    setSubmitting(false)
                  }}
                  // validationSchema={ValidationSchema}
                >
                  {props => {
                    const {
                      values,
                      touched,
                      errors,
                      isSubmitting,
                      handleChange,
                      handleBlur,
                      setFieldValue,
                      handleSubmit,
                      resetForm
                    } = props
                    return (
                      <div className="row" style={{ position: 'relative' }}>
                        <div className="col-md-12">
                          <form onSubmit={handleSubmit}>
                            {/* {JSON.stringify(values)} */}

                            <div className="row">
                              <div className="form-inline search-container">
                                <div className="col-lg-12 col-sm-12">
                                  <label>برند</label>
                                  <AsyncBrandSelect
                                    clearable
                                    brandType={
                                      this.props.categoryType === 0 ? 0 : 1
                                    }
                                    defaultValue={values.brandId}
                                    onChange={val => {
                                      setFieldValue(
                                        'brandId',
                                        val ? val : undefined
                                      )
                                    }}
                                    className="semantic-select-box"
                                  />
                                </div>

                                <div className="col-lg-12 col-sm-12">
                                  <label>نام کالا</label>

                                  <input
                                    type="text"
                                    onChange={e => {
                                      setFieldValue('name', e.target.value)
                                    }}
                                    value={
                                      values && values.name ? values.name : ''
                                    }
                                    name="name"
                                    className="text-input"
                                  />
                                </div>

                                <div className="clearfix form-row" />

                                <div className="col-lg-12 col-sm-12">
                                  <label>کد کالا</label>

                                  <input
                                    type="text"
                                    onChange={e => {
                                      setFieldValue(
                                        'extraCode',
                                        parseInt(e.target.value, 0)
                                      )
                                    }}
                                    value={
                                      values && values.extraCode
                                        ? values.extraCode
                                        : ''
                                    }
                                    name="extraCode"
                                    className="text-input"
                                  />
                                </div>

                                <div className="col-lg-6 col-sm-12">
                                  <label>کد سفارش</label>

                                  <DecimalInput
                                    type="tel"
                                    value={
                                      values && values.taskCode
                                        ? values.taskCode
                                        : undefined
                                    }
                                    onChange={e => {
                                      setFieldValue('taskCode', e.target.value)
                                    }}
                                    className="text-input"
                                  />
                                </div>

                                <div className="col-lg-6 col-sm-12">
                                  <label>تاریخ سفارش</label>

                                  <DatePicker
                                    onChange={e => {
                                      setFieldValue('date', e)
                                    }}
                                    value={
                                      values && values.date ? values.date : ''
                                    }
                                    name="date"
                                    className="text-input"
                                  />
                                </div>

                                <div className="clearfix form-row" />

                                <div className="col-md-12">
                                  <button
                                    type="submit"
                                    className="btn btn-primary btn-block"
                                    disabled={isSubmitting}>
                                    {loading ? (
                                      <i className="mdi mdi-spin mdi-loading" />
                                    ) : (
                                      <i className="mdi mdi-magnify" />
                                    )}
                                    &nbsp; جستجو &nbsp;
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    )
                  }}
                </Formik>
              </DialogContent>
            </Dialog>
          </div>
          <Tabs
            transition={false}
            id="controlled-tab-example"
            className="shift-manager-tabs"
            activeKey={activeTab}
            visible={tab_title ? true : false}
            onSelect={activeTab =>
              this.setState({ activeTab: activeTab, selectUnitModal: true })
            }>
            <Tab
              eventKey="tasks"
              taskStatus={0}
              title={
                <>
                  <FaBars
                    size="14px"
                    style={{ verticalAlign: 'middle', marginLeft: 10 }}
                  />
                  {tab_title}
                </>
              }
              style={{ minHeight: 'unset' }}>
              {data && data.length > 0 && !loading ? (
                <table className="table validator-table tasks-table">
                  <thead>
                    <tr>
                      <th className="text-center">ردیف</th>
                      <th className="text-center">کد سفارش</th>
                      <th className="text-center">دسته بندی</th>
                      <th className="text-center">برند</th>
                      <th className="text-center">نام کالا</th>
                      <th className="text-center">تاریخ آخرین بروزرسانی</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data &&
                      data.map((item, index) => (
                        <tr
                          key={'p-' + index}
                          style={{
                            height: 70
                          }}
                          onClick={() => this.handleModalEdit(item)}
                          className={
                            item.unitTaskStatus === 2
                              ? 'pointer selected-row'
                              : 'pointer'
                          }>
                          <td>{index + 1}</td>
                          <td>
                            <TaskCode code={item.taskCode} />
                          </td>
                          <td>{item.product && item.product.category.name}</td>
                          <td>{item.product && item.product.brand.name}</td>
                          <td>{item.product && item.product.name}</td>
                          <td>
                            {item.createdAt &&
                              moment(item.updatedAt, 'YYYY/M/D H:m').format(
                                'jYYYY/jM/jD ساعت H:mm'
                              )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              ) : dto.unitId && !loading ? (
                <div className="text-center" style={{ padding: 20 }}>
                  هیچ سفارشی برای این دستگاه یافت نشد
                </div>
              ) : (
                ''
              )}
            </Tab>
          </Tabs>
          {loading ? <Loading /> : ''}
        </div>

        <Dialog
          open={this.state.selectUnitModal}
          TransitionComponent={Transition}
          scroll={'paper'}
          fullWidth={true}
          maxWidth="sm"
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description">
          <DialogTitle
            className="text-center"
            style={{ paddingTop: 10, paddingBottom: 5 }}>
            <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}>
              لطفا دستگاهی که با آن کار می‌کنید را انتخاب کنید
            </h4>
          </DialogTitle>
          <DialogContent
            dividers={true}
            style={{ paddingTop: 5, paddingBottom: 5 }}>
            <UnitSelectBtnList
              unitType="7"
              onChange={(val, name) => this.handleUnitSelect(val, name)}
            />
          </DialogContent>
        </Dialog>

        <Dialog
          open={this.state.modal}
          onClose={this.handleModalHide}
          TransitionComponent={Transition}
          scroll={'paper'}
          fullScreen={true}
          // maxWidth="lg"
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description">
          {/* <DialogTitle>
            <Fab color="secondary" aria-label="refresh" size="small" onClick={() => this.handleModalHide()} className="modal-close-btn">
              <MdClose size="20px" />
            </Fab>
            <span style={{ marginRight: 10 }}></span>
          </DialogTitle> */}
          <DialogContent dividers={true} style={{ minHeight: 225 }}>
            {model.unitTaskStatus === 2 ? (
              <Form
                onSubmit={() => this.handleModalHideAndReload()}
                id={model.id}
                taskType={this.state.taskType}
                categoryType={this.props.categoryType}
                onClose={() => this.handleModalHide()}
                isModal={true}
              />
            ) : model.unitTaskStatus === 1 ||
              model.unitTaskStatus === 8 ||
              model.unitTaskStatus === 9 ? (
              <StartTaskForm
                onSubmit={() => this.handleModalHideAndReload()}
                id={model.id}
                taskType={this.state.taskType}
                categoryType={this.props.categoryType}
                unitId={this.state.unitId}
                onClose={() => this.handleModalHide()}
                isModal={true}
              />
            ) : (
              ''
            )}
          </DialogContent>
        </Dialog>

        <MySweetAlert
          show={this.state.confirmDeleteShow}
          onCancel={this.handleSweetAlertHide}
          onConfirm={this.handleConfirmDelete}
          title={'آیا از حذف کالا  [' + model.name + '] مطمئن هستید؟'}
        />
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { authentication } = state
  const { user } = authentication
  return {
    user
  }
}
const connectedSClumTasks = connect(mapStateToProps)(SClumTasks)
export { connectedSClumTasks as SClumTasks }
